import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { BaseService } from '../shared/services/base.service';
import { MetricaTipoAtividade } from '../models/metrica.tipo.atividade.model';
import { Page } from '../models/page.model';
import { MetricaTipo } from '../models/metrica.tipo.model';
import { MetricaAtividade } from '../models/metrica.atividade.model';
import { MetricaComplexidade } from '../models/metrica.complexidade.model';
import { MetricaTipoAtividadeCliente } from '../models/metrica.tipo.atividade.cliente.model';

@Injectable({
  providedIn: 'root'
})
export class MetricaService extends BaseService<MetricaTipoAtividade> {

  constructor(protected injector: Injector) {
    super(`${environment.API_PRICE}/metrica`, injector);
  }

  getMetricaTipo(): Observable<Page<MetricaTipo>> {
    return this.http.get<Page<MetricaTipo>>(`${environment.API_PRICE}/metrica/metrica-tipo`);
  }

  saveTipo(metrica: MetricaTipo): Observable<MetricaTipo> {
    return this.http.post<MetricaTipo>(`${environment.API_PRICE}/metrica/metrica-tipo`, metrica);
  }

  getMetricaAtividade(): Observable<Page<MetricaAtividade>> {
    return this.http.get<Page<MetricaAtividade>>(`${environment.API_PRICE}/metrica/metrica-atividade`);
  }

  saveAtividade(metrica: MetricaAtividade): Observable<MetricaAtividade> {
    return this.http.post<MetricaAtividade>(`${environment.API_PRICE}/metrica/metrica-atividade`, metrica);
  }

  getMetricaComplexidade(): Observable<Page<MetricaComplexidade>> {
    return this.http.get<Page<MetricaComplexidade>>(`${environment.API_PRICE}/metrica/metrica-complexidade`);
  }

  saveComplexidade(metrica: MetricaComplexidade): Observable<MetricaComplexidade> {
    return this.http.post<MetricaComplexidade>(`${environment.API_PRICE}/metrica/metrica-complexidade`, metrica);
  }

  deleteMetrica(id: number, metrica: string) {
    return this.http.get(`${environment.API_PRICE}/metrica/delete/${id}/${metrica}`);
  }

  getMetricaTipoAtividade(): Observable<Page<MetricaTipoAtividade>> {
    return this.http.get<Page<MetricaTipoAtividade>>(`${environment.API_PRICE}/metrica/metrica-tipo-atividade`);
  }

  getAllMetrica(): Observable<Page<MetricaTipoAtividade>> {
    return this.http.get<Page<MetricaTipoAtividade>>(`${environment.API_PRICE}/metrica/get-all-metrica-tipo-atividade`);
  }

  deleteMetricaTipoAtividade(id: number) {
    return this.http.delete(`${environment.API_PRICE}/metrica/delete-metrica-tipo-atividade/${id}`);
  }

  getMetricaAtividadeById(idMetricaTipo: number): Observable<MetricaAtividade[]> {
    return this.http.get<MetricaAtividade[]>(`${environment.API_PRICE}/metrica/getMetricaAtividadeById/${idMetricaTipo}`);
  }

  getMetricaComplexidadeById(idMetricaTipo: number, idMetricaAtividade: number): Observable<MetricaComplexidade[]> {
    return this.http.get<MetricaComplexidade[]>(`${environment.API_PRICE}/metrica/getMetricaComplexidadeById/${idMetricaTipo}/${idMetricaAtividade}`);
  }

  addMetricaTipoAtividade(metricaTipoAtividade: MetricaTipoAtividade) {
    return this.http.post(`${environment.API_PRICE}/metrica/AddMetricaTipoAtividade`, metricaTipoAtividade);
  }

  updateMetricaTipoAtividade(metricaTipoAtividade: MetricaTipoAtividade) {
    return this.http.put(`${environment.API_PRICE}/metrica/updateMetricaTipoAtividade`, metricaTipoAtividade);
  }

  getAllMetricaTipoById(idTipo: number) {
    return this.http.get(`${environment.API_PRICE}/metrica/GetAllMetricaTipoById/${idTipo}`)
  }

  getAllMetricaAtividadeById(idAtividade: number) {
    return this.http.get(`${environment.API_PRICE}/metrica/GetAllMetricaAtividadeById/${idAtividade}`)
  }

  getAllMetricaComplexidadeById(idComplexidade: number) {
    return this.http.get(`${environment.API_PRICE}/metrica/GetAllMetricaComplexidadeById/${idComplexidade}`)
  }

  getMetricaTipoAtividadePorCliente(clienteId: number): Observable<Page<MetricaTipoAtividadeCliente>> {
    return this.http.get<Page<MetricaTipoAtividadeCliente>>(`${environment.API_PRICE}/metrica/get-metrica-tipo-atividade-cliente/${clienteId}`);
  }

  gravarMetricaTipoAtividadeCliente(itemMetrica: MetricaTipoAtividadeCliente) {
    return this.http.put(`${environment.API_PRICE}/metrica/gravarMetricaTipoAtividadeCliente`, itemMetrica);
  }

  getAllMetricaTipoAtivas() {
    return this.http.get(`${environment.API_PRICE}/metrica/getAllMetricaTipoAtivas`)
  }
}